import React, { isValidElement } from 'react';
import isString from 'lodash/isString';
import flatMap from 'lodash/flatMap';
import formatTemplate from './formatTemplate';
export function formatReactTemplate(template, map) {
    let result = [template];
    const keys = Object.keys(map);
    const { length } = keys;
    keys.forEach((key, index) => {
        const node = map[key];
        result = flatMap(result, (text) => {
            if (isString(text)) {
                let stringText = text;
                if (isValidElement(node)) {
                    const placeholder = `{${key}}`;
                    const { length } = placeholder;
                    const textArr = [];
                    let index = stringText.indexOf(placeholder);
                    while (index > -1) {
                        if (index > 0) {
                            textArr.push(stringText.slice(0, index));
                        }
                        textArr.push(node);
                        stringText = stringText.slice(index + length);
                        index = stringText.indexOf(placeholder);
                    }
                    if (stringText) {
                        textArr.push(stringText);
                    }
                    return textArr;
                }
                return formatTemplate(text, { [key]: node }, index < length - 1);
            }
            return text;
        });
    });
    if (result.every(isString)) {
        return result.join('');
    }
    return (React.createElement(React.Fragment, null, result));
}
export default formatReactTemplate;
